import { baseStoreCreator } from '@common-fe/common-fe';

export interface EditEmail {
  employeeProvidedEmail: string;
  isEmployeeEmailPreferred: boolean;
}

export const DEFAULT_VALUES: EditEmail = {
  employeeProvidedEmail: '',
  isEmployeeEmailPreferred: true,
};

export const useStore = baseStoreCreator<EditEmail>(DEFAULT_VALUES);

export default useStore;
